import Row from 'blocks/Row';
import styled from 'styled-components';
export const LangChangerWrapper = styled(Row)`
  cursor: pointer;
  width: auto;
`;

export const LangChanger = styled.span<{ $color }>`
  color: ${({ $color }) => ($color === 'white' ? '#fff ' : '#1F2C51')};
  display: block;
  margin-inline-start: ${({ theme }) => theme.spacing.x1};
`;
